module.exports = __webpack_public_path__ + "static/media/PD_DBS_logo_blue.8df352d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/LayoutHeader/PD_DBS_logo_blue.svg
// module id = 1417
// module chunks = 2